export default {
  'page-title': 'Sistema di autorizzazione alla restituzione della merce (RMA) - Creative Labs (Italy)',
  'page-desc': 'Check the status of your return request with your RMA number. ',
  'mode-of-contact': 'Modalità di contatto',
  'your-details': 'I tuoi dettagli',
  'rma-request': 'Richiesta RMA',
  'first-name': 'Nome',
  'last-name': 'Cognome',
  'enter-first-name': 'Inserisci il tuo nome',
  'enter-last-name': 'Inserisci il tuo cognome',
  'email-address': 'Indirizzo email',
  'enter-email': 'Inserisci il tuo indirizzo email',
  'enter-valid-email': 'Inserisci un indirizzo email valido',
  'enter-pid': 'Please enter your personal ID',
  'super-x-fi': 'Super X-Fi',
  'products': 'Prodotti',
  'sale': 'Promozione',
  'help': 'Aiuto',
  'account': 'Account',
  'sign-in': 'Accedi',
  'loading-page': 'Caricamento in corso',
  'orders': 'Ordini',
  'membership-program': 'Programma soci',
  'account-profile': 'Profilo dell\'account',
  'contact-us': 'Contattaci',
  'sign-out': 'Disconnessione',
  'recent-orders': 'Ordini Recenti',
  'view-all-orders': 'Visualizza tutti gli ordini',
  'email_registered': {
    'text1': 'L\'email è già stata registrata ',
    'link': 'Accedi',
    'text2': ' per recuperare la cronologia degli ordini'
  },
  'country-region': 'Paese / Regione',
  'select-country': 'Seleziona la nazione',
  'preferred-language': 'Lingua preferita per la risposta',
  'select-language': 'Seleziona la lingua',
  'next': 'Avanti',
  'encountered-error': 'Abbiamo riscontrato un errore. Riprova',
  'your-enquiry': 'La tua richiesta',
  'nature-enquiry': 'Natura della richiesta',
  'order-number': 'Numero d\'ordine',
  'order-id': 'ID ordine',
  'for-amazon-order': 'Per ordini effettuati tramite Amazon',
  'enter-order-number': 'Inserisci il numero d\'ordine',
  'rma-number': 'Numero RMA',
  'enter-rma-number': 'Inserisci il tuo numero RMA',
    'purchase_creative_com': {
    'text': 'Se il prodotto difettoso è stato acquistato da Creative.com   ',
    'link': 'richiedi qui una sostituzione '
  },
  'not-purchase-creative-com': '<p>Se non hai acquistato direttamente da Creative.com, contatta il tuo rivenditore per qualsiasi richiesta di reso.</p><p><a href="https://it.creative.com/help/garanzia-e-resi" target="_blank">Fai clic qui per informazioni su garanzia e  restituzione.</a></p>',
  'not-purchase-creative-com-retailer-replacement': 'Se non hai acquistato da Creative.com, contatta direttamente il rivenditore per la richiesta di sostituzione.',
  'not_purchase_creative_com_2': {
    'text': 'Se il prodotto difettoso non è stato acquistato direttamente da Creative.com ',
    'link': 'richiedi qui una sostituzione '
  },
  'order-not-found': 'Il numero d\'ordine inserito non è stato trovato nei nostri archivi. Inserisci un numero d\'ordine valido.',
  'rma-not-found': 'Il numero RMA inserito non è stato trovato nei nostri archivi. Inserisci un numero RMA valido.',
  'previous-order': 'Ordine precedente',
  'next-order': 'Ordine successivo',
  'add-your-product': 'Aggiungi il tuo prodotto',
  'search-by-name': 'Cerca per nome prodotto',
  'select-product': 'Seleziona il prodotto',
    'upload-proof-update-date': {
      'text1': 'Fornisci la prova di acquisto e la data di acquisto. <br/>Se non si dispone della prova di acquisto, la preghiamo di ',
      'link': 'contattarci qui',
      'text2': ' .'
  },
  'return-product': 'Restituisci il prodotto',
  'return-products': 'Restituisci prodotto/i',
  'replace-defective-product': 'Sostituisci il prodotto difettoso',
  'check-rma-status': 'Controlla lo stato RMA',
  'service-request': 'Richieste di servizio disponibili',
  'select-one-service': 'Seleziona una richiesta di servizio. Se hai più di una richiesta di servizio per lo stesso ordine, apri una richiesta di servizio diversa per ogni problema. ',
  'select-one-servcie-2': 'Seleziona una richiesta di servizio.',
  'refund-products': 'Rimborsa prodotto',
  'qualifies-refund': 'Solo {} si qualifica per un rimborso ai sensi della Garanzia di Soddisfazione. <> Modifica i prodotti prima di procedere.',
  'replace-products': 'Sostituisci prodotto/i difettoso/i',
  'qualifies-replace': 'Solo {} si qualifica per una sostituzione. <> Modifica i prodotti prima di procedere.',
  'contact-us-assistance': 'Contattaci per assistenza',
  'return-information': 'Informazioni sulla restituzione',
  'replacement-information': 'Informazioni sulla sostituzione',
  'fill-in-all': 'Compila tutti i campi di questa sezione.',
  'message': 'Messaggio',
  'enter-message': 'Inserisci il tuo messaggio.',
  'submit': 'Invia richiesta',
  'submission-successful': 'La tua richiesta è stata inviata.',
  'contact-us-thank-you': 'Ti risponderemo entro 2 giorni lavorativi.',
  'back-to-home': 'Torna alla pagina principale',
  'confirmation': 'Conferma',
  'rma-confirmation': 'Conferma RMA',
  'refresh-page': 'Ricarica',
  'loading': 'Caricamento in corso…',
  'select': 'Seleziona indirizzo',
  'selected': 'Selezionato',
  'update': 'Modifica indirizzo',
  'address': 'Indirizzo',
  'new-address': 'Nuovo indirizzo  ',
  'edit': 'Modifica',
  'update-address': 'Modifica indirizzo',
  'cancel': 'Annulla',
  'back': 'Indietro',
  'select-your-products': 'Seleziona i tuoi prodotti',
  'serial-number': 'Numero di serie',
  'returns-eligibility': 'Idoneità al reso',
  'warranty': 'Garanzia',
  'proof-purchase': 'Prova d\'acquisto',
  'purchase-date': 'Data di acquisto',
  'select-date': 'Data di acquisto',
  'how-find-serial-num': 'Come trovare il numero di serie?',
  'yes': 'Sì',
  'no': 'No',
  'choose-file': 'Scegli il file',
  'upload-supporting-file': 'Carica immagine a supporto',
  'remove': 'Rimuovi',
  'warranty-days-left': '{warrantyDaysRemain} giorno/i rimasto/i',
  'out-warranty': 'Fuori garanzia',
  'enter-serial': 'Inserisci il numero di serie',
  'enter-serial-number': 'Inserisci un numero di serie valido.',
  'serial-not-valid': 'Inserisci numero di serie',
  'serial-num-submitted': 'Numero di serie già inviato, inseriscine un altro.',
  'file-formats-allowed': 'Formati di file consentiti: JPG, PNG, ZIP. Dimensione massima del file: 4 MB.',
  'thank-you-rma-submit': 'Grazie per averci inviato la richiesta RMA.',
  'provide-rma-number': 'Fornisci il numero RMA al nostro Servizio Clienti se ci stai contattando in merito a questo RMA.',
  'retrieve_rma_status': {
    'text': 'Puoi anche recuperare informazioni sullo stato dell\'RMA o apportare modifiche all\'RMA registrando ',
    'link': 'un account Creative Store'
  },
'product-details': 'Dettagli prodotto',
  'product': 'Prodotto',
  'rma-details': 'Dettagli RMA',
  'service-request2': 'Richiesta di servizio',
  'refund': 'Rimborso',
  'replacement': 'Sostituzione',
  'rma-status': 'Stato RMA',
  'expires-date': 'Scadenza  {date}',
  'refund-estimated-cost': 'Nota: l\'importo del rimborso è attualmente una stima e potrebbe essere soggetto a ulteriori modifiche.',
  'service-fee': 'Costo del servizio',
  'service-fee-text': 'Una tassa di servizio può essere riscossa se il prodotto restituito mostra segni di danni accidentali o abuso. Verrai contattato via e-mail, se applicabile.',
  'product-is-defective': 'Prodotto difettoso',
  'repair-status-list': [
    {
      'status': 'Richiesta RMA ricevuta',
      'desc': '<p>La richiesta RMA è attualmente in fase di elaborazione.</p><p><i>(Richiede solitamente 1-2 giorni lavorativi)</i></p>'
    },
    {
      status: 'RMA approvato',
      desc: `<div class="return-instruction">
                <div id="display_eu" style="display:{display_eu}">
                  Fai riferimento all'e-mail (Oggetto: La richiesta di reso a Creative Labs è stata approvata) per le istruzioni di restituzione.
                  È possibile generare l'etichetta di spedizione del reso tramite il seguente collegamento inserendo le informazioni come di seguito:
                  <p style="margin:10px auto">
                    URL: <a href="{courierLabelLink}" target="_blank">{courierLabelLink}</a> <br>
                    Numero dell’ordine:  <span style='font-weight:500'>{orderNumber}</span> <br>
                    Codice di restituzione:   <span style='font-weight:500'>{b2cTrackingNumber}</span> <br>
                  </p>
                  <p>
                    Tieni presente che l'etichetta di spedizione può essere utilizzata una sola volta.
                  </p>
                </div>

                <div id="display_others" style="display:{display_others}">
                  Fai riferimento all'e-mail (Oggetto: La richiesta di reso a Creative Labs è stata approvata) per le istruzioni di restituzione.
                  <p id="display_shippingLabel1" style="margin:10px auto;{display_shippingLabel}">
                    L'etichetta di spedizione deve essere scaricata entro 90 giorni.
                    Una volta effettuato l'accesso per la prima volta, l'etichetta deve essere scaricata o stampata entro 5 giorni,
                    dopodiché non sarà più accessibile.<br>
                      <a href="{courierLabelLink}" target="_blank" style="text-decoration:underline">Etichetta di spedizione</a>
                  </p>
                  <p id="display_shippingLabel2" style="margin:10px auto;{display_shippingLabel}">
                  Tieni presente che l'etichetta di spedizione può essere utilizzata una sola volta.
                  </p>
                </div>
            </div>`
    },
    {
      status: 'Prodotto ricevuto',
      desc: '<p>Stiamo verificando il prodotto restituito.</p><p><i>(Richiede solitamente 1-2 giorni lavorativi)</i></p>',
    },
    {
      status: 'Sostituzione in preparazione',
      desc: '<p>Stiamo verificando la disponibilità di magazzino dell\'unità sostitutiva.</p><p><i>(Richiede solitamente 1-2 giorni lavorativi)</i></p>',
    },
    {
      status: 'Spedizione in preparazione',
      desc: '<p>Stiamo preparando l\'unità sostitutiva per la spedizione.</p><p><i>(Richiede solitamente 1-2 giorni lavorativi)</i></p>',
    },
    {
      status: 'Sostituzione spedita',
      desc: '<p>L\'unità sostitutiva è stata spedita.  <br /></p>',
    }
  ],
  'refund-status-list': [
    {
      'status': 'Richiesta RMA ricevuta',
      'desc': '<p>La richiesta RMA è attualmente in fase di elaborazione.</p><p><i>(Richiede solitamente 1-2 giorni lavorativi)</i></p>'
    },
    {
      status: 'RMA approvato',
      desc: `<div class="return-instruction">
                <div id="display_eu" style="display:{display_eu}">
                  Fai riferimento all'e-mail (Oggetto: La richiesta di reso a Creative Labs è stata approvata) per le istruzioni di restituzione.
                  È possibile generare l'etichetta di spedizione del reso tramite il seguente collegamento inserendo le informazioni come di seguito:
                  <p style="margin:10px auto">
                    URL: <a href="{courierLabelLink}" target="_blank">{courierLabelLink}</a> <br>
                    Numero dell’ordine:  <span style='font-weight:500'>{orderNumber}</span> <br>
                    Codice di restituzione:   <span style='font-weight:500'>{b2cTrackingNumber}</span> <br>
                  </p>
                  <p>
                    Tieni presente che l'etichetta di spedizione può essere utilizzata una sola volta.
                  </p>
                </div>

                <div id="display_others" style="display:{display_others}">
                  Fai riferimento all'e-mail (Oggetto: La richiesta di reso a Creative Labs è stata approvata) per le istruzioni di restituzione.
                  <p id="display_shippingLabel1" style="margin:10px auto;{display_shippingLabel}">
                    L'etichetta di spedizione deve essere scaricata entro 90 giorni.
                    Una volta effettuato l'accesso per la prima volta, l'etichetta deve essere scaricata o stampata entro 5 giorni,
                    dopodiché non sarà più accessibile.<br>
                      <a href="{courierLabelLink}" target="_blank" style="text-decoration:underline">Etichetta di spedizione</a>
                  </p>
                  <p id="display_shippingLabel2" style="margin:10px auto;{display_shippingLabel}">
                    Tieni presente che l'etichetta di spedizione può essere utilizzata una sola volta.
                  </p>
                </div>
            </div>`
    },
    {
      status: "Prodotto ricevuto",
      desc: "<p>Stiamo verificando il prodotto restituito.</p><p><i>(Richiede solitamente 1-2 giorni lavorativi)</i></p>",
    },
    {
      status: "Rimborso in elaborazione",
      desc: "<p>Il prodotto è stato verificato e stiamo elaborando il tuo rimborso<span style='{showAmount}'> di EUR <strong>{RefundAmtActual}</strong></span>.</p><p><i>(Richiede solitamente 3-5 giorni lavorativi)</i></p>",
    },
    {
      status: "Rimborso completato",
      desc: "<p>Abbiamo completato il rimborso sul metodo di pagamento originale. Potrebbero essere necessari fino a 30 giorni affinché la tua banca elabori la richiesta. Contatta la banca per ulteriori informazioni.</p><p><i>Abbiamo completato il rimborso sul metodo di pagamento originale. Potrebbero essere necessari fino a 30 giorni affinché la tua banca elabori la transazione. Contatta la banca per ulteriori informazioni.</i></p>",
    }
  ],
  'what-are-reason': 'Qual è il motivo del ritorno?',
  'which-part-defective': 'Quale parte del prodotto è difettosa?',
  'please-select-one': 'Seleziona…',
  'cosmetic-damages': 'Sono presenti danni fisici / cosmetici sul prodotto?',
  'attach-photo': 'Allega una foto del danno:',
  'comments': 'Commenti',
  'enter-comments': 'Ti chiediamo di inserire una descrizione dettagliata della tua richiesta.',
  'rma-exists': 'È stata inviata una richiesta di RMA per questo prodotto.',
  'rma-created': 'Esiste già una richiesta RMA per questo prodotto e non può essere nuovamente creata.',
  'rma-cancelled': 'La tua richiesta RMA è stata annullata. In caso di domande sulla cancellazione della richiesta RMA, non esitare a contattarci.',
  'selected-maximum': 'Hai selezionato la quantità massima consentita.',

  'shipping-information': 'Informazioni sulla spedizione',
  'shipping-address': 'Indirizzo di spedizione',
  'select-shipping-address': 'Selezionare indirizzo di spedizione',
  'replace-sent-address': 'Seleziona l’indirizzo a cui verrà inviata la sostituzione: ',
  'product-purchased-from': 'Prodotto acquistato da',
  'creative-store': 'Creative Store',
  'all-other-retailers': 'Tutti gli altri rivenditori',
 'product-not-received': 'Non ricevuto',
  'product-cancelled': 'Annullato',
  'rma-closed': 'Chiudere',
  'select-mode-of-contact': 'Selezionare la modalità di contatto.',
  'email-us': 'Inviaci un\'e-mail',
  'your-order': 'Il tuo ordine',
  'refund-amount': 'Importo del rimborso',
  'shipping-charge': 'Spese di spedizione',
  'store-credit': 'Crediti Negozio',
  'tax': 'Tasse',
  'deliver-unable-info':'Non possiamo consegnare a caselle postali, hotel, motel e i seguenti territori d\'oltremare. <a href="/help/consegna#what-are-the-overseas-territories-that-you-don-39-t-deliver-to" target="_blank">Per saperne di più</a>.',
  'creative-in-warranty': '',
  'extended-warranty': '',
  'maintenance-msg': `Avviso: il sito Web subirà una manutenzione programmata per offrirti un servizio migliore. La manutenzione è prevista domenica 09 Ottobre 2022, dalle 9:00 alle 15:00 (GMT +8:00). Durante questo periodo, i nostri siti Web non saranno accessibili.
                      <br><br>
                      Ci scusiamo per l'inconveniente causato e ti ringraziamo per la pazienza.`,
  'shipping-country-notice-it': `Questo sito spedisce solo in Italia, ed esclude tutti i territori d'oltremare come Livigno e Campione d'Italia. Inoltre, non siamo in grado di consegnare a caselle postali, packstation, hotel, motel e altro ancora. <a href="/help/consegna#dove-spedite" target="_blank">Scopri di più</a>.`
}